import React, { useState } from 'react';
import { Dialog, Button, DialogContent } from '@mui/material';
import './formulaire.scss';
import StepOne from './Steps/step1';
import StepTwo from './Steps/step2';
import StepThree from './Steps/step3';
import StepFour from './Steps/step4';

export default function Formulaire() {
  const [open, setOpen] = useState(false);
  const [datas, setDatas] = useState({ mode: 'public', conditions: false });
  const [step, setStep] = useState(1);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setStep(1);
    setDatas({ mode: 'public', conditions: false });
  };

  function getFormStep() {
    switch (step) {
      case 1:
        return <StepOne datas={datas} handleChange={handleChange} next={nextStep} />
      case 2:
        return <StepTwo datas={datas} handleChange={handleChange} next={nextStep} prev={prevStep} />
      case 3:
        return <StepThree datas={datas} handleChange={handleChange} next={nextStep} prev={prevStep} />
      case 4:
        return <StepFour datas={datas} handleChange={handleChange} prev={prevStep} handleClose={setOpen}/>
    }
  }

  function prevStep() {
    setStep(step - 1);
  }

  function nextStep() {
    setStep(step + 1);
  }

  function handleChange(datas) {
    setDatas(datas);
  }

  return (
    <div>
      <Button
        variant="contained"
        color="error"
        size="large"
        onClick={handleOpen}>Je veux donner mon opinion sur le changement d'usage</Button>
      <Dialog
        open={open}
        onClose={handleClose}
        scroll='paper'
        maxWidth='lg'
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogContent dividers={true}>
            {getFormStep()}
        </DialogContent>
      </Dialog>
    </div>
  );
}